<template>
  <button
    type="button"
    class="scroll-to-bottom-button"
    :class="{ 'with-counter': counter }"
    @click="$emit('onClick')"
  >
    <BaseSubHeading
      v-if="counter"
      size="small"
      weight="600"
      class="scroll-to-bottom-button__counter"
      color="monochrome-06"
      darkColor="monochrome-01"
    >
      {{ counter > 99 ? "99+" : counter }}
    </BaseSubHeading>
    <icon
      :data="require('@icon/chevron-with-paddings.svg')"
      width="var(--icon-24)"
      height="var(--icon-24)"
      :fill="true"
      class="scroll-to-bottom-button__icon"
      dir="right"
    />
  </button>
</template>

<script setup lang="ts">
defineProps({
  counter: {
    type: Number,
    default: 0
  }
})

defineEmits(["onClick"])
</script>

<style scoped lang="scss">
@import "@/assets/scss/utils/mixins/_flex";

.scroll-to-bottom-button {
  padding: var(--step1);
  border: none;
  border-radius: 50%;
  background-color: var(--monochrome-00);
  box-shadow: var(--center-02);
  color: var(--monochrome-05);
  cursor: pointer;

  &:hover {
    color: var(--monochrome-06);
    opacity: 0.75;
  }

  &.with-counter {
    height: auto;
    border-radius: 80px;
    gap: var(--step1);

    @include flex($direction: column);
  }
}

.dark {
  .scroll-to-bottom-button {
    background: var(--monochrome-01);
    color: var(--monochrome-04);

    &:hover {
      color: var(--monochrome-06);
    }
  }
}
</style>
